import { render, staticRenderFns } from "./GrantsTable.vue?vue&type=template&id=ce60fba0&"
import script from "./GrantsTable.vue?vue&type=script&lang=js&"
export * from "./GrantsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports